import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { subirINoticia, db } from "../../firebase/firebase.config";
import { collection, addDoc } from "firebase/firestore";
import EditorDeTexto from './EditorDeTezto'; 
import './CargarNoticia.css';

function CargarNoticia() {
  const [titulo, setTitulo] = useState('');
  const [imagen, setImagen] = useState(null);
  const [contenido, setContenido] = useState('');
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);

  const handleTituloChange = (e) => {
    setTitulo(e.target.value);
    setErrors((prev) => ({ ...prev, titulo: null }));
  };

  const handleImagenChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      setImagen(selectedImage);
      setErrors((prev) => ({ ...prev, imagen: null }));
    }
  };

  const handleContenidoChange = (content) => {
    setContenido(content);
    setErrors((prev) => ({ ...prev, contenido: null }));
  };

  useEffect(() => {
    if (!imagen) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(imagen);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [imagen]);

  const validate = () => {
    const nextErrors = {};
    if (!titulo.trim()) nextErrors.titulo = 'Campo obligatorio.';
    if (!imagen) nextErrors.imagen = 'Debe adjuntar una imagen.';
    if (!contenido || contenido.trim() === '<p><br></p>') nextErrors.contenido = 'Debe completar el contenido.';
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const enviarNoticia = async () => {
    if (isSubmitting) return;
    if (!validate()) return;
    setIsSubmitting(true);

    try {
        const { url, imageName } = await subirINoticia(imagen); // Obtener la URL y el nombre de la imagen
        const timestamp = Date.now();
      const noticiaData = {
        id: timestamp,
        titulo: titulo,
        imagenUrl: url,
        contenido: contenido,
        timestamp: timestamp,
        nombreimagen:imageName,
      };

      await addDoc(collection(db, 'noticias'), noticiaData);

      alert('Noticia cargada correctamente');
      setTitulo('');
      setImagen(null);
      setContenido('');
    } catch (error) {
      console.error(error);
      alert('Error al cargar la noticia. Inténtalo de nuevo.'+error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="cargar-noticia">
      <div className="cargar-noticia__header">
        <h3>Cargar Noticia</h3>
        <p className="text-muted">Completá los campos y publicá la noticia.</p>
      </div>

      <div className="cargar-noticia__content">
        <div className="row g-3">
          <div className="col-lg-5">
            <div className="card p-3 h-100">
              <label className="form-label">Título *</label>
              <input
                type="text"
                placeholder="Título de la noticia"
                value={titulo}
                onChange={handleTituloChange}
                className={`form-control${errors.titulo ? ' is-invalid' : ''}`}
              />
              {errors.titulo && <div className="invalid-feedback">{errors.titulo}</div>}

              <div className="mt-3">
                <label className="form-label">Imagen principal *</label>
                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  onChange={handleImagenChange}
                  className={`form-control${errors.imagen ? ' is-invalid' : ''}`}
                />
                <div className="form-text">Recomendado: 1200 x 630 px o similar.</div>
                {errors.imagen && <div className="invalid-feedback">{errors.imagen}</div>}
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="card p-3 h-100">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label m-0">Previsualización de imagen</label>
                {previewUrl && <span className="badge bg-success">Lista</span>}
              </div>
              {previewUrl ? (
                <div className="cargar-noticia__preview">
                  <img src={previewUrl} alt="Previsualización" />
                </div>
              ) : (
                <div className="cargar-noticia__preview-empty">
                  Subí una imagen para verla acá
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row g-3 mt-1">
          <div className="col-12">
            <div className="card p-3">
              <label className="form-label">Contenido *</label>
              <EditorDeTexto onChange={handleContenidoChange} value={contenido} />
              {errors.contenido && <div className="invalid-feedback d-block">{errors.contenido}</div>}
            </div>
          </div>
        </div>
      </div>

      <div className="cargar-noticia__actions">
        <button className="btn btn-outline-secondary" onClick={() => setShowPreview(true)}>
          Previsualizar
        </button>
        <button className="btn btn-primary" onClick={enviarNoticia} disabled={isSubmitting}>
          {isSubmitting ? 'Publicando...' : 'Publicar noticia'}
        </button>
      </div>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Previsualización</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="cargar-noticia__preview-modal">
            <h3 className="mb-3">{titulo || 'Título de la noticia'}</h3>
            {previewUrl && (
              <div className="cargar-noticia__preview-modal-image">
                <img src={previewUrl} alt="Imagen de la noticia" />
              </div>
            )}
            <div
              className="cargar-noticia__preview-modal-content"
              dangerouslySetInnerHTML={{ __html: contenido || '<p>(Sin contenido)</p>' }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPreview(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CargarNoticia;
